<!-- palce holder while view is set -->
<!-- <button class="adming-btn" *ngIf="user.user.userid == 'PHIL'" mat-raised-button (click)="view = view == 'user'? 'dashboard': 'user'">change view</button> -->
<!-- <button class="adming-btn" *ngIf="showHistory" mat-raised-button (click)="openReprints()">Re-print</button> -->

<ng-template #containerAddModal let-modal>
	<!-- moving to its own component - finish sso first -->
	<div class="modal-header" *ngIf="activeStageType.shippername">
		<h4 class="modal-title" id="modal-title">{{activeStageType.shippername}} NEW CONTAINER</h4>
		<button type="button" class="btn-close" id="containeraddclose" aria-label="Close" (click)="modal.dismiss('Cross click')"><i class="fa fa-close"></i></button>
	</div>
	<div class=modal-body *ngIf="activeStageType.shippername">
		<div class="row w-100 m-0 p-0 justify-content-between">
			<input matInput  placeholder="container #" [formControl]="containerRef">
			<button mat-mini-fab color="success" [disabled]="!containerRef.value.length" (click)="saveContainer(activeStageType, containerRef.value)">
				<mat-icon>add</mat-icon>
			</button>
		</div>
	</div>
</ng-template>



<ng-template #ocAlertModal let-modal>
	<!-- moving to its own component - finish sso first -->
	<div class="modal-header bg-success text-white" *ngIf="userocdata">
		<h4 class="modal-title" id="modal-title">CONFIRMING <b>{{userocdata.shippername}}</b>&nbsp;<b class="font-weight-lighter">{{userocdata.container ?? 'LIVE'}}</b> </h4>
		<svg *ngIf="userocdata" class="spinner align-middle" width="25px" height="25px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg"> <circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"> </circle> </svg>
	</div>
	<div class="modal-body">
		<div class="table table-bordered mat-elevation-z2 w-100">
			<thead>
				<tr class="table-header-tr-dark">
					<th>ORDERNO</th>
					<th>BUYER</th>
					<th>QTY</th>
					<th>SKU</th>
				</tr>
			</thead>
			<tbody *ngIf="userocdata && userocdata?.orders?.orders">
				<tr *ngFor="let ord of userocdata.orders.orders" class="w-100">
					<td>{{ord.orderno}}</td>
					<td>{{ord.deliverto}}</td>
					<td class="text-center">{{ord.details[0].quantity}}</td>
					<td>{{ord.details[0].stkcode}}</td>
				</tr>
			</tbody>
		</div>
	</div>
</ng-template>

<ng-template #reprintModal let-modal>
	<!-- moving to its own component - finish sso first -->
	<div class="modal-header">
		<h4 class="modal-title" id="modal-title">Sticker Batch History</h4>
		<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"><i class="fa fa-close"></i></button>
	</div>
	<div class=modal-body>
		<div class="m-0 p-0 col-11 ml-auto mr-auto">
			<input class="reprint-input w-100" type="text" [formControl]="historySearchRef" id="historySearchRef" autocomplete="off" placeholder="Sku, Order#, Name, Batch, Date, User..." (keyup)="historySearch();" #searchRef/>
		</div>
		<div class="m-0 p-0 col-12 ml-auto mr-auto" *ngIf="batchHistoryFiltered">
			<table class="w-100 table table-fixed">
				<ng-container *ngFor="let batch of batchHistoryFiltered">
					<thead>
						<tr>
							<th colspan="7">BATCH: {{batch['batchid']}}</th>
							<th><button mat-raised-button class="btn-sm float-right">Re-Print Batch</button></th>
						</tr>
						<tr>
							<th>Order#</th>
							<th>Track#</th>
							<th>Buyer</th>
							<th>QTY</th>
							<th>Sku</th>
							<th>Time RTS</th>
							<th>Time LOADED</th>
							<th>Time Shipped</th>
						</tr>
					</thead>
					<tbody>
						<tr *ngFor="let ord of batch['orders']" [ngClass]="{'highlight' : historymatches.length && historymatches.includes(ord.orderno)}">
							<td>{{ord.orderno}}</td>
							<td>{{ord.trackingnumber}}<a *ngIf="ord.trackingnumber | trackingUrl as ssoU" class="tracking-link ml-1 align-middle" [href]="ssoU" target="_blank" rel="noopener noreferrer" title="Track"><mat-icon style="font-size:16px;width:16px;height:16px;">open_in_new</mat-icon></a></td>
							<td>{{ord.name}}</td>
							<td>{{ord.quantity}}</td>
							<td>{{ord.stockid}}</td>
							<td>{{ord.packeduserid}} @ {{ord.packedtime}} </td>
							<td>{{ord.stageduserid}} @ {{ord.stagedtime}} </td>
							<td>{{ord.ocuserid}} @ {{ord.shippedtime}} </td>
						</tr>
					</tbody>
				</ng-container>
			</table>
		</div>
	</div>
</ng-template>



<ng-template #scanTypeModal let-modal>
	<div class="modal-header">
		<div class="row m-0 p-0 w-100 justify-content-between">
			<div class="col-4 m-0 p-0" *ngIf="showContainerSelection && activeStageType">
				<button class="font-size-sm italics w-100" color="accent" mat-stroked-button (click)="activeStageType = false; showContainerSelection = false">Back</button>
			</div>
			<div class="col-auto m-0 p-0">
				<h4 class="w-100 modal-title" id="modal-title" *ngIf="!activeStageType">Load Type Selection</h4>
				<h4 class="w-100 modal-title" id="modal-title" *ngIf="activeStageType && showContainerSelection">{{activeStageType['shippername'] | uppercase}} CONTAINERS</h4>
				<!-- <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"><i class="fa fa-close"></i></button> -->
			</div>
		</div>
	</div>
	<div class=modal-body>
		<div class="m-0 p-0 col-12 ml-auto mr-auto" *ngIf="!activeStageType">
			<ng-container *ngFor="let shipper of allshipvias">
				<hr class="m-1 p-0 w-100"/>
				<div class="w-100 m-1 p-1 justify-content-between row type-selection">
					<div class="w-50 m-0 p-0">
						<button color="primary" class="w-100 m-0 p-0 shipper-badge" mat-raised-button (click)="setType(shipper, false)" [matBadge]="shipper.liveload.ordercount > 0  ? '!' : ''">
							<mat-icon>local_shipping</mat-icon>
							{{shipper.shippername}}&nbsp;LIVE
						</button>
						<br/>
					</div>
					<div class="w-25 m-0 p-0">
						<button color="accent" class="w-100 m-0 p-0 shipper-badge" mat-stroked-button (click)="setType(shipper, true)" [matBadge]="shipper.activecontainers > 0  ? shipper.activecontainers : ''">
							<span class="font-size-sm font-weight-lighter italics">Container</span>
						</button>
					</div>
				</div>
			</ng-container>
		</div>
		<div class="m-0 p-0 col-12 ml-auto mr-auto" *ngIf="activeStageType  && showContainerSelection">
			<div class="w-100 m-1 p-1">
				<button class="btn-success color-white" mat-stroked-button (click)="addNewContainer()">
					<mat-icon>add</mat-icon> Add new container?
				</button>
			</div>
			<ng-container *ngFor="let container of this.activeStageType['containers']">
				<div class="w-100 m-1 p-1 justifiy-content-center container-row" (click)="setContainer(container.container_id)">
					<span> {{container.container_id | uppercase}} </span>
					<span class="font-size-sm italic font-weight-lighter bg-success rounded-pill text-white pl-2 pr-2" *ngIf="container.ordercount">PROG.</span>
					<span class="font-size-sm italic font-weight-lighter" *ngIf="container.ordercount">ORDS&nbsp;<b>{{container.ordercount}}</b></span>
					<span class="font-size-sm italic font-weight-lighter" *ngIf="container.units">UNITS&nbsp;<b>{{container.units}}</b></span>
				</div>
			</ng-container>

		</div>
	</div>
</ng-template>

<svg *ngIf="view === ''" class="spinner" width="65px" height="65px" viewBox="0 0 66 66"
	xmlns="http://www.w3.org/2000/svg">
	<circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30">
	</circle>
</svg>


<div *ngIf="view === 'dashboard'" class="main-content move-up">
	<div class="row w-100 mt-2 justify-content-end " *ngIf="enableAdminControls">
			<div class="mr-1 p-0 admin-controls">
				<div class="control">
					<span>Require all tracking #'s for loading</span><mat-slide-toggle [formControl]="allTrackingToLoadRef" matToolTip="This is a global toggle and affects other users. Requires all tracking #s to be scanned to mark an order loaded."></mat-slide-toggle>
				</div>
			</div>
			<div class="m-0 mr-1 p-0 admin-controls">
				<div class="control">
					Click to load<mat-slide-toggle [formControl]="adminStatusRef"></mat-slide-toggle>
				</div>
			</div>
		<button mat-stroked-button (click)="changeView(view)">Change view</button>
	</div>

	<!-- error row -->
	<div class="row m-0 p-0 w-100 error-row text-center" [ngClass]="hasError ? 'show-err' : 'hide-err'" (click)="dismissError()">
		<b class="error-row p-3 mat-elevation-z4 focus">{{errorMsg}}</b>
	</div>

	<div class="row m-0 p-0 w-100">
		<div class="col-6 m-0 p-1 text-center dashboard-table">
			<div class="card m-0 p-0">
				<div class="row m-0 p-0 info-block">
					<div class="m-auto p-0" [ngClass]="lastPacked ? 'w-50' : 'w-100'">
						<h4>RTS</h4>
						<hr class="m-0 p-0">
						<div class="row w-100 p-0 m-0 text-center" *ngIf="currentCounts">
							<p class="col-5 m-0 p-0 unitcount">ORDERS <b class="font-size-xlg p-2">&nbsp;{{currentCounts['packed']['orders']}}</b></p>
							<mat-divider class="col-1 m-0 p-0" [vertical]="true"></mat-divider>
							<p class="col-5 m-0 p-0 unitcount">UNITS <b class="font-size-xlg p-2">&nbsp;{{currentCounts['packed']['units']}}</b></p>
						</div>
					</div>
					<div class="w-50 m-auto p-1" *ngIf="lastPacked">
						<div class="row m-0 p-0 justify-content-between info-block-last lastpack">
							<div class="col-6 m-0 p-0 text-left">
								<div class="w-100 m-0 p-0 float-left"><b>{{lastPacked.so[0].buyername}}</b></div>
								<div class="w-100 m-0 p-0 float-left">{{lastPacked.so[0].deliverto}}</div>
							</div>
							<div class="col-6 m-0 p-0 text-right status-25 rounded pr-1 pt-1 pb-1">
								<div class="w-100 m-0 p-0 float-right">#<b class="font-size-lg">{{lastPacked.orderno}}</b></div>
								<div class="w-100 m-0 p-0 float-right"><mat-icon class="vert-mid">local_shipping</mat-icon>{{lastPacked.trackingnumber}}</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="spacer"></div>
			<div class="card dashboard-table mt-0 scroll-overflow">
				<table class="w-100 m-0 p-0 table-fixed table-hover table-bordered table-striped">
					<thead>
						<tr class="table-header-tr">
							<th>ORDER#</th>
							<th>TYPE</th>
							<th>TRACK#</th>
							<th>CUST.</th>
							<th>SKU</th>
							<th>QTY</th>
							<th>STATUS</th>
							<th>PACKED BY</th>
						</tr>
					</thead>
					<tbody>
						<ng-container *ngFor="let ord of stagedOrders">
							<tr *ngIf="ord.statusid == 25" class="table-body-tr">
								<td>{{ord.orderno}}</td>
								<td>{{ord.type}}</td>
								<td>{{ord.trackingnumber}}<a *ngIf="ord.trackingnumber | trackingUrl as ssoU2" class="tracking-link ml-1 align-middle" [href]="ssoU2" target="_blank" rel="noopener noreferrer" title="Track"><mat-icon style="font-size:16px;width:16px;height:16px;">open_in_new</mat-icon></a></td>
								<td>{{ord.name}}</td>
								<td>{{ord.stockid}}</td>
								<td>{{ord.quantity}}</td>
								<td class="status-{{ord.statusid}}">{{ord.statusid == 25 ? 'RTS' : ''}}</td>
								<td>{{ord.packedtime}}&nbsp;<span class="p-1 pr-2 pl-2 text-white bg-dark rounded-pill">{{ord.packeduserid}}</span></td>
							</tr>
						</ng-container>
					</tbody>
				</table>
			</div>
		</div>
		<div class="col-6 m-0 p-1 text-center dashboard-table">
			<div class="card m-0 p-0">
				<div class="row m-0 p-0 info-block">
					<div class="w-50 m-auto p-1" *ngIf="lastStaged">
						<div class="row m-0 p-0 justify-content-between info-block-last laststage">
							<div class="col-6 m-0 p-0 text-left status-24 rounded pl-1 pt-1 pb-1">
								<div class="w-100 m-0 p-0 float-left">#<b class="font-size-lg">{{lastStaged.orderno}}</b></div>
								<div class="w-100 m-0 p-0 float-left">{{lastStaged.trackingnumber}}<mat-icon class="vert-mid">local_shipping</mat-icon></div>
							</div>
							<div class="col-6 m-0 p-0 text-right">
								<div class="w-100 m-0 p-0 float-right"><b>{{lastStaged.so[0].buyername}}</b></div>
								<div class="w-100 m-0 p-0 float-right">{{lastStaged.so[0].deliverto}}</div>
							</div>
						</div>
					</div>
					<div class="m-auto p-0" [ngClass]="lastStaged ? 'w-50' : 'w-100'">
						<h4>LOADED</h4>
						<hr class="m-0 p-0">
						<div class="row w-100 p-0 m-0 text-center" *ngIf="currentCounts">
							<p class="col-5 m-0 p-0 unitcount">ORDERS <b class="font-size-xlg p-2">&nbsp;{{currentCounts['staged']['orders']}}</b></p>
							<mat-divider class="col-1 m-0 p-0" [vertical]="true"></mat-divider>
							<p class="col-5 m-0 p-0 unitcount">UNITS <b class="font-size-xlg p-2">&nbsp;{{currentCounts['staged']['units']}}</b></p>
						</div>
					</div>
				</div>
			</div>
			<div class="spacer"></div>
			<div class="card dashboard-table mt-0">

				<!-- testing new format -->
				<ng-container *ngFor="let shipper of dashboardStaged | keyvalue">
					<div class="w-100 m-0 p-0" class="shipper-table mb-3 mat-elevation-z4 {{shipper.key}}-border" *ngFor="let type of shipper.value | keyvalue; let i = index;">
						<table class="w-100 m-0 p-0 table-fixed table-hover table-bordered table-striped">
							<thead>
								<tr class="font-size-lg" [ngClass]="{'UPS': shipper.key.toUpperCase() === 'UPS', 'FedEx': shipper.key.toUpperCase() === 'FEDEX', 'confirming-tr': activeOc.container == containerByIndex(shipper, i) && activeOc.shippername == shipper.key}">
									<th colspan="10">
										<div class="w-100 m-0 p-1 row">
											<div *ngIf="activeOc.shippername == shipper.key && activeOc.container == containerByIndex(shipper, i)">
												CONFIRMING
												<svg class="spinner" width="22px" height="22px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg"> <circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"> </circle> </svg>
											</div>
											<div class="trans d-flex align-self-center" id="{{shipper.key}}-{{containerByIndex(shipper, i)}}">
												{{shipper.key}}
												<ng-container *ngIf="containerByIndex(shipper, i) !== 'live'">&nbsp;
													<span class="container-tr tr-{{shipper.key}}">
														<mat-icon class="d-inline vert-align-bottom">view_in_ar</mat-icon>
														<b>{{containerByIndex(shipper, i)}}</b>
													</span>
												</ng-container>
												<ng-container *ngIf="containerByIndex(shipper, i) === 'live'">&nbsp;
													<span class="container-tr tr-{{shipper.key}}">
														<mat-icon class="d-inline vert-align-bottom">local_shipping</mat-icon>
														<b>LIVE LOAD</b>
													</span>
												</ng-container>
											</div>
											<button mat-stroked-button class="oc-btn pos-abs-right d-none" *ngIf="enableAdminControls" (click)="admin_confirm(shipper, type)">OC</button>
										</div>
										
									</th>
								</tr>
								<tr class="bg-white table-header-tr">
									<th>LINE</th>
									<th>ORDER#</th>
									<th>TYPE</th>
									<th>CONTAINER?</th>
									<th>TRACK#</th>
									<th>CUST.</th>
									<th>SKU</th>
									<th>QTY</th>
									<th>STATUS</th>
									<th>LOADED BY</th>
								</tr>
							</thead>
							<tbody>
								<ng-container *ngFor="let ord of type.value; let i = index">
									<tr *ngIf="ord.statusid == 24" class="table-body-tr">
										<td>{{type.value.length - i}}</td>
										<td>{{ord.orderno}}</td>
										<td>{{ord.type}}</td>
										<td>{{ord.container_id  == '' ? 'LIVE LOAD' : ord.container_id}}</td>
										<td>{{ord.trackingnumber}}<a *ngIf="ord.trackingnumber | trackingUrl as ssoU3" class="tracking-link ml-1 align-middle" [href]="ssoU3" target="_blank" rel="noopener noreferrer" title="Track"><mat-icon style="font-size:16px;width:16px;height:16px;">open_in_new</mat-icon></a></td>
										<td>{{ord.name}}</td>
										<td>{{ord.stockid}}</td>
										<td>{{ord.quantity}}</td>
										<td class="status-{{ord.statusid}}">{{ord.statusid == 24 ? 'LOADED' : ''}}</td>
										<td>{{ord.stagedtime}}&nbsp;<span class="p-1 pr-2 pl-2 bg-dark text-white rounded-pill">{{ord.stageduserid}}</span></td>
									</tr>
								</ng-container>
							</tbody>
						</table>
					</div>
				</ng-container>
			</div>
		</div>
	</div>
</div>




<div *ngIf="view === 'user'" class="main-content overflow-scroll smaller-height main-height" #mainContent>
	<div *ngIf="!picking && !signing.status && !isKeyboardOpen" class="m-0 col-auto top-display" [ngClass]="{'w-100' : currentProduct && currentProduct.hasOrders ? true : false}">
		<ng-container *ngIf="currentProduct && currentProduct.hasOrders">
			<div class="w-100 m-0 p-0 font-size-md row justify-content-end floating-product ov-clip">
				<div class="row m-0 p-0">
					<div class="row m-0 p-0 w-100 justify-content-start">
						<mat-icon color="primary" class="sku-viewing">visibility</mat-icon>
						<p class="item-stockid  d-inline">( {{ currentProduct.stockid }} )</p>
						<p class="item-title d-inline">{{ currentProduct.description }}</p>
					</div>
				</div>
			</div>
		</ng-container>
	</div>

	<div class="w-100 text-center" *ngIf="!picking && (searchsub || skusub)">
		<svg class="spinner m-auto text-center" width="65px" height="65px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
			<circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"> </circle>
		</svg>
	</div>


	<!-- product slected view -->
	<ng-container *ngIf="!picking && currentProduct">
		<!-- avail orders for selection when under a prodcut -->
		<ng-container *ngIf="availableOrders.length">
			<ul class="list-unstyled scale-5">
				<li *ngFor="let ord of availableOrdersFiltered" (click)="stageOrder(ord)" [ngClass]="{'notpickedorder' : !ord.picked}">
					<div class="col-12 m-auto p-1 order-card card" [ngClass]="{'orderstaged-notconfirmed': orderIsStaged(ord.orderno) && !ord.confirmed,'orderstaged-confirmed': orderIsStaged(ord.orderno) && ord.confirmed, 'orderstaged-printed': orderIsStaged(ord.orderno) && (ord.labelPrinted || ord.status == 'RTS'), 'focus': ord.orderno == orderToConfirm.orderno}">
						<div class="w-100 m-0 p-0 bg-tracking">
							<div class="m-0 p-0 w-100 font-size-sm">
								<span class="packing-type rounded border">
									{{ord.type}}
									<ng-container  *ngIf="ord.requiresBinding">
										<ng-container *ngIf="!ord.sticker || !['24','25'].includes(ord.sticker.statusid)">
											<span class="bg-warning text-dark">BIND REQ</span>
										</ng-container>
										<ng-container *ngIf="ord.sticker && ['24','25'].includes(ord.sticker.statusid)">
											<span class="bg-success text-white">BOUND</span>
										</ng-container>
									</ng-container>
								</span>
							</div>
							<h4 *ngIf="!ord.picked" class="m-0 p-0">NOT PICKED</h4>
							<ng-container *ngFor="let trk of ord.tracking">
								<h4 class="float-left m-0 p-0 w-100" [ngClass]="{'bg-danger text-white': !trk.trackingnumber}">
									TRACK#: {{ trk.trackingnumber ?? 'NO TRACK # ASSIGNED'}}
									<mat-icon class="m-0 p-0 trk-confirmed" *ngIf="trk.confirmed">check_circle</mat-icon>
								</h4>
							</ng-container>
						</div>
						<div class="w-100 m-0 p-0" >
							<h4 class="float-left m-0 p-0">#{{ord.orderno}}</h4>
							<h4 class="float-right m-0 p-0">{{ord.debtorno}}.{{ord.branchcode}}</h4>
							<br/>
							<div class="m-0 p-0 w-100 row">
								<div class="m-0 p-0 col-6-gap text-left"> {{ord.buyername}} </div>
								<div class="m-0 p-0 col-6-gap text-right"> {{ord.deliverto}} </div>
							</div>
							<hr class="m-0" />
						</div>
						<ng-container *ngIf="ord.details">
							<div *ngFor="let line of ord.details" class="w-100 row m-0 p-0 text-left order-line font-size-sm">
								<div class="m-0 p-0 col-11">
									<b class="font-size-md">{{line.stkcode}}</b>&nbsp;&nbsp;
									<br/>
									{{line.itemdesc}}&nbsp;&nbsp;
								</div>
								<div class="m-0 p-0 col-1 text-right">
									<span class="line-quantity" [ngClass]="{'bg-danger text-white': !orderToConfirm.skusconfirmed, 'bg-warning text-dark':(orderToConfirm.skusconfirmed < orderToConfirm.skucount) && orderToConfirm.skusconfirmed > 0, 'bg-success text-white': (orderToConfirm.skusconfirmed === orderToConfirm.skucount) && orderToConfirm.skusconfirmed > 0}" 
										*ngIf="orderToConfirm.orderno == ord.orderno">
										<mat-icon *ngIf="orderToConfirm.skusconfirmed != orderToConfirm.skucount || !orderToConfirm.skusconfirmed" class="qty-indicator">east</mat-icon>
										 &nbsp;{{orderToConfirm['skusconfirmed'] ?? 0}}&nbsp;
									</span> 
									<span class="line-quantity">x<b>{{line.quantity}}</b></span>
								</div>
							</div>
						</ng-container>
					</div>
					<br/>
				</li>
			</ul>
		</ng-container>

		<!-- no orders avail when under a product -->
		<ng-container *ngIf="currentProduct && !currentProduct.hasOrders">
			<div class="w-100 m-0 p-0 text-center" (click)="resetProduct()">
				<h4 class="no-order-warning">
					<b>NO STICKER ORDERS AVAIL FOR {{currentProduct.stockid.toUpperCase()}}</b>
				</h4>
			</div>
		</ng-container>
	</ng-container>


	<!-- ambigious search sku table for select = no product selected -->
	<ng-container *ngIf="!picking && showSkuTable">
		<table class="table table-sm table-hover skutable">
			<thead class="sticky-thead">
				<tr>
					<th></th>
					<th class="text-left">ITEM</th>
					<th class="text-left">DESC</th>
				</tr>
			</thead>
			<tbody *ngIf="availableSkus.length">
				<ng-container *ngFor="let item of availableSkus">
					<tr (click)="loadItem(item.stockid)">
						<td> <a mat-raised-button class="width: 20px">Select</a></td>
						<td class="text-left f12">
							{{ item.stockid }}
						</td>
						<td class="text-left ">{{ item.description }}</td>
					</tr>
				</ng-container>
			</tbody>
			<tbody *ngIf="!availableSkus.length">
				<tr class="text-center text-dark">
					<td colspan="3">
						<br/>
						<mat-icon class="text-danger">warning</mat-icon>
						<br/>
						NO ITEMS MATCH <b class="text-danger italics">{{lastSearchedCode.toUpperCase()}}</b>
					</td>
				</tr>
			</tbody>
		</table>
	</ng-container>

	<div class="m-1 p-1 w-100 overflow-none pos-rel" *ngIf="!picking && signing.status">
		<app-electric-signature class="m-0 p-0" (signatureEmit)="OCOrders($event)" [signatureBase64]="signing.value" [canvasHeight]="250"></app-electric-signature>
	</div>
	<div class="row m-0 p-0 active-stage-row" *ngIf="activeStageType && stageMode && !picking">
		<h4>
			<mat-icon *ngIf="!activeStageType.container" class="trk-confirmed">local_shipping</mat-icon>
			<b>{{activeStageType.shippername.toUpperCase()}}&nbsp;</b>
			<span *ngIf="activeStageType.container">CONTAINER #<b>{{activeStageType.container | uppercase}}</b></span>
		</h4>
	</div>
	<!-- staged order user view of current packed orders awaiting to ship -->
	<ng-container *ngIf="!currentProduct && !showSkuTable && !searchsub && !skusub && !signing.status">
		<div class="row w-100 m-0 p-0" [ngClass]="picking ? 'top-display' : ''">
			<div class="row w-100 mt-1 mb-4 justify-content-between ml-auto mr-auto admin-panel mat-elevation-z2" *ngIf="enableAdminControls && showFilter">
				<div class="col-9 m-0 p-0">
					<div class="admin-controls mb-0">
						<div class="control" matToolTip="'This will'">
							<span>All TRK #'s to load</span><mat-slide-toggle class="float-right" [formControl]="allTrackingToLoadRef"></mat-slide-toggle>
						</div>
					</div>
					<br class="m-0 p-0"/>
					<div class="admin-controls mt-0">
						<div class="control">
							Click to load<mat-slide-toggle class="float-right" [formControl]="adminStatusRef"></mat-slide-toggle>
						</div>
					</div>
				</div>
				<button class="m-0 p-0" mat-stroked-button (click)="changeView(view)">Change view</button>
			</div>

			<br class="m-0 p-0"/>

			<div class="m-0 p-0 col-10 row" (click)="showFilter = !showFilter">
				<div class="col-4 m-0 p-0">
					<div class="w-100 m-0 p-0" *ngIf="currentCounts">
						<p class="m-0 p-0">RTS</p>
						<hr class="m-0 p-0" />
						<p class="m-0 p-0">LOADED</p>
						<br/>
					</div>
				</div>
				<div class="col-8 m-0 p-0">
					<div class="w-100 m-0 p-0" *ngIf="currentCounts">
						<div class="row m-0 p-0 justify-content-between">
							<div>Orders:&nbsp;<b>{{currentCounts['packed']['orders']}}</b></div>
							<div>Units:&nbsp;<b>{{currentCounts['packed']['units']}}</b></div> 
						</div>
						<hr class="m-0 p-0"/>
						<div class="row m-0 p-0 justify-content-between">
							<div>Orders:&nbsp;<b>{{currentCounts['staged']['orders']}}</b></div>
							<div>Units:&nbsp;<b>{{currentCounts['staged']['units']}}</b></div>
						</div>
						<br/>
					</div>
				</div>
			</div>
			<div class="col-2 m-0 p-0">
				<button mat-mini-fab (click)="togglePicking()" class="picking-btn">
					<mat-icon>swap_horiz</mat-icon>
				</button>
			</div>
		</div>

		<div class="row m-0 p-0" *ngIf="showFilter">
		

			<mat-form-field appearance="outline" class="w-50 m-0 p-0" >
				<mat-label>STATUS</mat-label>
				<mat-select [formControl]="ordTypeFilter">
					<mat-option [value]="'all'">
						ALL
					</mat-option>
					<mat-option *ngFor="let t of orderTypes" [value]="t.value">
						{{ t.view }}
					</mat-option>
				</mat-select>
			</mat-form-field>
			<mat-form-field appearance="outline" class="w-50 m-0 p-0">
				<mat-label>SHIPPER</mat-label>
				<mat-select [formControl]="shipperTypeFilter">
					<mat-option [value]="'all'">
						ALL
					</mat-option>
					<mat-option *ngFor="let t of allshipvias" [value]="t.shipper_id">
						{{ t.shippername }}
					</mat-option>
				</mat-select>
			</mat-form-field>
		</div>
	
		<hr class="m-0 p-0"/>
		<div class="w-100 m-0 p-0 row justify-content-between" *ngIf="!picking">
			<div class="ml-0 mr-0 mb-2" *ngFor="let ord of stagedOrders" [ngClass]="{'tobeshipped' : stageMode && ord.statusid == 24, 'notship' : stageMode && ord.statusid != 24, 'col-12 ord-box-full':ord.moreinfo || ord.orderno == loadingOrder.orderno, 'col-6-gap ord-box': !ord.moreinfo, 'opacity-full': ord.orderno == loadingOrder.orderno}" (dblclick)="moreInfo(ord)" id="{{ord.orderno}}">
				<div class="w-100 m-0 p-0 row ord-head" [ngClass]="{'stage-pattern' : ord.statusid == 24}">
					<div class="col-6-gap m-0 p-0 text-left">
						#{{ord.orderno}}
						&nbsp;
						<span [ngClass]="{'bg-success text-white': ord.statusid != 24, 'bg-warning text-dark': ord.statusid == 24}" *ngIf="this.loadingOrder.orderno == ord.orderno">
							<ng-container *ngIf="ord.statusid == 24">
								UN-LOADING
							</ng-container>
							<ng-container *ngIf="ord.statusid != 24">
								LOADING
							</ng-container>
						</span>
					</div>
					<div class="col-6-gap m-0 p-0 text-right font-size-sm nowrap">
						<span class="staged-type-container">
							<span class="{{ord.type}} track-pill br-dotted pl-1 pr-1"> {{ord['type']}} </span>
							<span class="status-{{ord.statusid?? ''}}"><b>{{ord.statusid == 25 ? 'R': ord.statusid == 24 ? 'L': ''}}</b></span>
						</span>
					</div>
				</div> 
				<ng-container *ngFor="let line of ord.details">
					<div class="font-size-sm w-100">{{line.stkcode}}&nbsp;x{{line.quantity}}</div>
				</ng-container>
				<hr class="w-100 p-0 m-0"/>
				<div class="m-0 p-0 w-100 font-size-sm">{{ord['buyername']}}</div>
				<hr class="w-100 p-0 m-0"/> 
				<hr class="w-100 p-0 m-0"/>
				<ng-container *ngIf="ord.moreinfo">
					<hr class="m-0 p-1"/>
					<ul class="entry-list p-0 m-0 font-size-xsm">
						<li *ngIf="ord.statusid == 24">
							<div class="spec-label mw-25 bg-white">
								Type:
							</div>
							<div class="spec-value">
								<span *ngIf="ord['container_id']">
									<mat-icon class="d-line vert-align-bottom half-scale">view_in_ar</mat-icon>{{ord['container_id']}}
								</span>
								<span *ngIf="!ord['container_id'] && ord.statusid == 24">&nbsp;<mat-icon class="d-line vert-align-bottom half-scale">local_shipping</mat-icon>LIVE LOAD</span>
							</div>
						</li>
						<li>
							<div class="spec-label mw-25 bg-white">
								To:
							</div>
							<div class="spec-value">
								{{ord.deliverto}}
							</div>
						</li>
						<li *ngIf="ord.requiresBinding">
							<div class="spec-label mw-25 bg-white">
								Binded?
							</div>
							<div class="spec-value">
								<span class="bg-success text-white ml-1 pl-1 pr-1">BOUND ORDER</span>
							</div>
						</li>
						<li *ngIf="ord.customerref">
							<div class="spec-label mw-25 bg-white">
								Ref
							</div>
							<div class="spec-value">
								{{ord.customerref}}
							</div>
						</li>
						<li>
							<div class="spec-label mw-25 bg-white">
								Track#
							</div>
							<div class="spec-value" [ngClass]="{'d-grid': ord.tracking.length > 2}">
								<ng-container *ngFor="let track of ord.tracking">
									<span [ngClass]=" {'bg-success text-white': track.confirmed }">{{track.trackingnumber}}&nbsp;</span>
								</ng-container>
							</div>
						</li>
						<li *ngIf="ord.enteredby">
							<div class="spec-label mw-25 bg-white">
								Entered By
							</div>
							<div class="spec-value">
								{{ord.enteredby}}
							</div>
						</li>
						<li>
							<div class="spec-label mw-25 bg-white">
								Packed By
							</div>
							<div class="spec-value">
								{{ord.packeduserid}} @ <span class="font-weight-lighter">{{ord.packedtime}}</span>
							</div>
						</li>
						<li *ngIf="ord.stageduserid">
							<div class="spec-label mw-25 bg-white">
								Loaded By
							</div>
							<div class="spec-value">
								{{ord.stageduserid}} @ <span class="font-weight-lighter">{{ord.stagedtime}}</span>
							</div>
						</li>
					</ul>
				</ng-container>
				<ng-container *ngIf="!ord.moreinfo">
					<ul class="entry-list p-0 m-0 font-size-xsm">
						<li>
							<div class="spec-label mw-25 bg-white">
								To:
							</div>
							<div class="spec-value">
								{{ord.deliverto}}
							</div>
						</li>
						<li *ngIf="ord.requiresBinding">
							<div class="spec-label mw-25 bg-white">
								Binded?
							</div>
							<div class="spec-value">
								<span class="bg-success text-white ml-1 pl-1 pr-1">BOUND ORDER</span>
							</div>
						</li>
						<li *ngIf="ord.statusid == 24">
							<div class="spec-label mw-25 bg-white">
								Type:
							</div>
							<div class="spec-value">
								<span *ngIf="ord['container_id']">
									<mat-icon class="d-line vert-align-bottom half-scale">view_in_ar</mat-icon>{{ord['container_id']}}
								</span>
								<span *ngIf="!ord['container_id'] && ord.statusid == 24">&nbsp;<mat-icon class="d-line vert-align-bottom half-scale">local_shipping</mat-icon>LIVE LOAD</span>
							</div>
						</li>
						<li *ngIf="ord.customerref">
							<div class="spec-label mw-25 bg-white">
								Ref
							</div>
							<div class="spec-value">
								{{ord.customerref}}
							</div>
						</li>
					</ul>
				</ng-container>
			</div>
		</div>

	</ng-container>

	<div class="w-100 m-0 p-0 bg-white picking-comp" *ngIf="picking">
		<app-order-pick [picksonly]="true" [shipvias]="stickershipvias"></app-order-pick>
	</div>


	<!-- floats above bottom nav to show expected scan type & additional information  -->
	<div *ngIf="!picking && !signing.status" class="m-0 col-auto warehouse-nav-above " [ngClass]="{'w-100' : currentProduct && currentProduct.hasOrders ? true : false}">
		<ng-container *ngIf="this.stageMode || (!this.stagemode && !this.currentProduct)">
			<div class="w-100 m-0 p-0  justify-content-start d-inline nowrap">
				<p class="font-size-sm italics mb-1" [innerHTML]="currentstep"></p>
			</div>
		</ng-container>
		<ng-container *ngIf="currentProduct && currentProduct.hasOrders">
			<div class="w-100 m-0 p-0 font-size-md row ">
				<div class="row m-0 p-0 w-100">
					<div class="col-2 m-0 p-0  justify-content-start">
						<p class="font-size-sm italics mb-1" [innerHTML]="currentstep"></p>
					</div>
					<div class="col-4 text-right m-0 p-0 vert-align d-flex justify-content-center">
						<mat-icon color="primary" class="sku-viewing">visibility</mat-icon>
						<p class="item-stockid m-auto d-inline nowrap">{{ currentProduct.stockid }}</p>
					</div>
					<div class="col-6 m-0 p-0 justify-content-end">
						<div class="row m-0 p-0">
							
							<div class="col-12 m-0 p-0 ov-clip">
								<p class="item-title link link_animated">{{ currentProduct.description }}</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</ng-container>
	</div>

	<!-- bottom nav = always vis -->
	<div class="warehouse-nav row ml-0 mr-0" *ngIf="!picking && !signing.status">

		<!-- exit product and complete scan out button -->
		<div class="col-2 m-0 p-0">
			<button mat-mini-fab [ngClass]="signing.value ? 'oc': 'needsignature'" *ngIf="!currentProduct && !showSkuTable && stageMode && pickupcount" [disabled]="!stagedOrders.length" (click)="confirmPickups()"> <mat-icon [matBadge]="pickupcount">local_shipping</mat-icon> </button>
			<button mat-mini-fab class="btn-success" *ngIf="!currentProduct && !showSkuTable && stageMode && !pickupcount" (click)="toggleStageMode()"> <mat-icon >cancel</mat-icon> </button>
			<button mat-mini-fab color="primary" *ngIf="!currentProduct && !showSkuTable && !stageMode" [disabled]="!stagedOrders.length" (click)="toggleStageMode()"><mat-icon>north</mat-icon></button>
			<button mat-mini-fab color="accent" *ngIf="((currentProduct && !orderToConfirm) || showSkuTable) && !stageMode" (click)="resetProduct()"><mat-icon>west</mat-icon></button>
			<button mat-mini-fab color="accent" *ngIf="currentProduct && orderToConfirm && !stageMode" (click)="resetOrderProcess()"><mat-icon>undo</mat-icon></button>
		</div>

		<!--1 : order look up by product sku/barcode -->
		<div class="input-container col-10 m-0 p-0" *ngIf="(!currentProduct || !currentProduct.hasOrders) && !stageMode">
			<input  ngxTouchKeyboard #touchKeyboard="ngxTouchKeyboard" (dblclick)="touchKeyboard.togglePanel()" type="text" [formControl]="skuSearchRef" id="searchRef" autocomplete="off" placeholder="Scan or Search tire..." (keyup.enter)="$event.stopPropagation(); $event.preventDefault(); orderSearch(); $event.target.blur();" #searchRef/>
			<button class="search-button" type="button" (click)="$event.stopPropagation(); $event.preventDefault(); orderSearch();"> 
				<svg *ngIf="skusub" class="spinner m-auto text-center" width="25px" height="25px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
					<circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30">
					</circle>
				</svg>
				<mat-icon *ngIf="!skusub">search</mat-icon> 
			</button>
		</div>
		<!--2 : order scan once in a product -->
		<div class="input-container col-10 m-0 p-0 tra step1" *ngIf="currentProduct && currentProduct.hasOrders && !orderToConfirm && !labelToPrint && !stageMode">
			<input ngxTouchKeyboard #touchKeyboard="ngxTouchKeyboard" (dblclick)="touchKeyboard.togglePanel()" type="text" [formControl]="labelScanRef" id="searchRef" autocomplete="off" placeholder="Scan, Select or Search order..." (keyup.enter)="$event.stopPropagation(); $event.preventDefault(); scanOrder(); $event.target.blur();" #searchRef />
			<button class="search-button" type="button" (click)="$event.stopPropagation(); $event.preventDefault(); scanOrder();"> <mat-icon>layers</mat-icon> </button>
		</div>
		<!--3: SKU SCANS OF EVERY TIRE -->
		<div class="input-container col-10 m-0 p-0 tra step2" *ngIf="currentProduct && currentProduct.hasOrders && orderToConfirm && ((orderToConfirm.skusconfirmed !== orderToConfirm.skucount) || !orderToConfirm.skusconfirmed) && !labelToPrint && !stageMode">
			<input ngxTouchKeyboard #touchKeyboard="ngxTouchKeyboard" (dblclick)="touchKeyboard.togglePanel()" type="text" [formControl]="fedexScanRef" id="searchRef" autocomplete="off" placeholder="Scan UPC label to confirm qty..." (keyup.enter)="$event.stopPropagation(); $event.preventDefault(); confirmOrder(); $event.target.blur();" #searchRef />
			<button class="search-button" type="button" (click)="$event.stopPropagation(); $event.preventDefault(); confirmOrder();"> <mat-icon>label</mat-icon> </button>
		</div>
		<!--3.5: fedex label confirmation once an order is scanned and a match was found -secondary scan to verify tracking label -->
		<div class="input-container col-10 m-0 p-0 tra step2-5" *ngIf="currentProduct && currentProduct.hasOrders && orderToConfirm && orderToConfirm.skusconfirmed && (orderToConfirm.skusconfirmed == orderToConfirm.skucount) && !labelToPrint && !stageMode">
			<input ngxTouchKeyboard #touchKeyboard="ngxTouchKeyboard" (dblclick)="touchKeyboard.togglePanel()" type="text" [formControl]="fedexScanRef" id="searchRef" autocomplete="off" placeholder="Scan fedex label to confirm..." (keyup.enter)="$event.stopPropagation(); $event.preventDefault(); confirmOrder(); $event.target.blur();" #searchRef />
			<button class="search-button" type="button" (click)="$event.stopPropagation(); $event.preventDefault(); confirmOrder();"> <mat-icon>local_shipping</mat-icon> </button>
		</div>
		<!-- 4: final scan of item to print the label - NOT BEING USED ANYMORE SINCE ALL TIRES BEING SCANNED ABOVE-->
		<div class="input-container col-10 m-0 p-0 tra step3" *ngIf="currentProduct && currentProduct.hasOrders && labelToPrint && !stageMode">
			<input ngxTouchKeyboard #touchKeyboard="ngxTouchKeyboard" (dblclick)="touchKeyboard.togglePanel()" type="text" [formControl]="itemScanRef" id="searchRef" autocomplete="off" placeholder="Scan item to print label..." (keyup.enter)="$event.stopPropagation(); $event.preventDefault(); printAndPack(); $event.target.blur();" #searchRef />
			<button class="search-button" type="button" (click)="$event.stopPropagation(); $event.preventDefault(); printAndPack();"> <mat-icon>label</mat-icon> </button>
		</div>
		<!--5: input box to scan to mark orders for pickup-->
		<div class="input-container col-10 m-0 p-0 tra step4" *ngIf="stageMode">
			<input ngxTouchKeyboard #touchKeyboard="ngxTouchKeyboard" (dblclick)="touchKeyboard.togglePanel()" type="text" [formControl]="stageScanRef" id="searchRef" autocomplete="off" placeholder="Scan order shipping label..." (keyup.enter)="$event.stopPropagation(); $event.preventDefault(); markOrderStaged(); $event.target.blur();" #searchRef />
			<button class="search-button" type="button" (click)="$event.stopPropagation(); $event.preventDefault(); markOrderStaged();"> <mat-icon>label</mat-icon> </button>
		</div>
	</div>
	<ng-container *ngIf="signing.status">
		<p class="italics font-weight-lighter">Please have the delivery driver sign</p>
	</ng-container>

</div>